import { FilterBarLabels } from "design-system/molecules/FilterBar"
import { useMemo } from "react"
import { useTranslation } from "react-i18next"

export function useFilterBarLabels() {
  const { t } = useTranslation()

  return useMemo<FilterBarLabels>(
    () => ({
      addFilter: t("shared.filterBar.add"),
      clear: t("shared.filterBar.clear"),
      clearFilters: t("shared.clearFilters"),
      removeFilter: t("shared.filterBar.remove"),
      search: t("shared.filterBar.search"),
      searchFor: (query) => t("shared.filterBar.searchFor", { query }),
      empty: t("shared.filterBar.empty"),
      selectedCount: (count) => t("shared.filterBar.selectedCount", { count }),
      any: t("shared.filterBar.any"),
    }),
    [t],
  )
}
